/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconNavigationCommunities = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      d="M6.336 5.346a1.032 1.032 0 0 1-.112-.472v-1.36a1.808 1.808 0 0 1 3.568 0v1.36c0 .164-.038.326-.112.472L8.8 6.362a.984.984 0 0 1-1.6 0l-.864-1.016zM10.2 7.21l.784.832c.376.388.586.908.584 1.448v4a.296.296 0 0 1-.296.296H4.728a.296.296 0 0 1-.296-.296v-4a2.08 2.08 0 0 1 .56-1.376l.8-.904a.296.296 0 0 1 .384-.048l1.368.888a.856.856 0 0 0 .912 0l1.368-.88a.296.296 0 0 1 .376.04zM2.624 4.082a1.336 1.336 0 0 1 1.312 1.184V6.29a.8.8 0 0 1-.088.384l-.648.8a.704.704 0 0 1-1.16-.016l-.648-.8a.8.8 0 0 1-.088-.368V5.266a1.336 1.336 0 0 1 1.32-1.184zm.76 4.352c.136-.072.312-.032.312.112v4.944a.264.264 0 0 1-.232.264h-3.2A.264.264 0 0 1 0 13.49v-3.6c.006-.442.17-.868.464-1.2l.528-.616c.087-.1.233-.12.344-.048l.984.664c.18.12.413.12.592 0l.472-.256zm10.576-.96a.704.704 0 0 1-1.168-.016l-.648-.8a.8.8 0 0 1-.088-.368V5.266a1.328 1.328 0 0 1 2.64 0V6.29a.8.8 0 0 1-.088.384l-.648.8zm1.576 1.216c.293.332.458.758.464 1.2v3.6a.264.264 0 0 1-.232.264h-3.2a.264.264 0 0 1-.264-.264V8.562c0-.12.176-.184.304-.12l.472.248c.18.12.413.12.592 0l.984-.656a.264.264 0 0 1 .344.048l.536.608z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

IconNavigationCommunities.displayName = 'IconNavigationCommunities';

IconNavigationCommunities.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconNavigationCommunities);
IconNavigationCommunities.displayName = 'IconNavigationCommunities';
